import styled from 'styled-components';
import BREAK_POINTS from 'packages/smart-home-support/styling/media-queries';

export default styled.div`
  margin-left: 18px;
  margin-right: 18px;
  margin-top: 45px;
  text-align: center;
  @media ${BREAK_POINTS.mobile} {
  }
  @media ${BREAK_POINTS.mobileBig} {
    margin-top: 70px;
    margin-left: 50px;
    margin-right: 50px;
  }
  @media ${BREAK_POINTS.tablet} {
    margin-left: 100px;
    margin-right: 100px;
  }
  @media ${BREAK_POINTS.desktop} {
    margin-left: 100px;
    margin-right: 100px;
  }
`;



// WEBPACK FOOTER //
// ./packages/smart-home-support/assets/components/ProtectItTextContainer.tsx